import { gql } from 'apollo-boost';

export const replaceKeywordsMutation = gql`
    mutation FindAndReplaceKeywordsMutation($input: GdFindAndReplaceKeywordsInput!, $login: String!) {
        reqId: getReqId
        findAndReplaceKeywords(input: $input) {
            cacheKey
            updatedTotalCount
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const deleteKeywords = gql`
    mutation DeleteKeywordsMutation($input: GdDeleteKeywordsInput!, $login: String!) {
        reqId: getReqId
        deleteKeywords(input: $input) {
            deletedKeywordIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const unsuspendKeywords = gql`
    mutation UnsuspendKeywordsMutation($input: GdUnsuspendKeywordsInput!, $login: String!) {
        reqId: getReqId
        unsuspendKeywords(input: $input) {
            unsuspendedKeywordIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const suspendKeywords = gql`
    mutation SuspendKeywordsMutation($input: GdSuspendKeywordsInput!, $login: String!) {
        reqId: getReqId
        suspendKeywords(input: $input) {
            suspendedKeywordIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const updateKeywords = gql`
    mutation UpdateKeywordsMutation($input: GdUpdateKeywordsInput!, $login: String!) {
        reqId: getReqId
        updateKeywords(input: $input) {
            updatedKeywords {
                id
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const addKeywordsMutation = gql`
    mutation AddKeywordsMutation($input: GdAddKeywordsInput!, $login: String!) {
        reqId: getReqId
        addKeywords(input: $input) {
            addedItems {
                keywordId
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const addAdGroupMinusKeywordsMutation = gql`
    mutation AddAdGroupMinusKeywordsMutation($input: GdAddAdGroupMinusKeywordsInput!, $login: String!) {
        reqId: getReqId
        addAdGroupMinusKeywords(input: $input) {
            addedItems {
                adGroupId
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;
